import React from 'react';
import PriceCard from '../PriceCard/PriceCard';
import './table.css';

/**
 * Displays a column for a specific size, containing all its products.
 * @param {object} props
 * @param {string|number} props.size The product size (used internally by TehranInventory).
 * @param {string} props.title The display title for the table.
 * @param {Array<object>} props.products The list of products for this size.
 * @param {function} props.onTitleClick Function to call when the title is clicked.
 * @param {boolean} props.isUnpricedShown Whether unpriced products are currently being shown for this table.
 */
const Table = ({ size, title, products, onTitleClick, isUnpricedShown }) => {
  if (!products || products.length === 0) {
    return null;
  }
  
  // Conditionally add a class when unpriced items are shown
  const titleClass = `sizetable-title ${isUnpricedShown ? 'unpriced-shown' : ''}`;
  
  return (
    <div className="sizetable-container">
      {/* 🖱️ Added onClick handler and inline style for pointer cursor */}
      <h2 
        className={titleClass} 
        onClick={onTitleClick}
        style={{ cursor: 'pointer', userSelect: 'none' }} // Ensure it looks clickable
      >
        {title}
        {/* Visual indicator when unpriced items are showing for this size */}
        {isUnpricedShown && (
            <span style={{ marginRight: '8px', fontSize: '0.9em', color: '#b7b7b7ff', fontWeight: 'normal' }}> 
                (بدون قیمت)
            </span>
        )}
      </h2>
      <div className="sizetable-content">
        {products.map((product) => (
          <PriceCard
            key={product.id} 
            price={product.price}
            title={product.title}
            description={product.description}
            icon={product.source}
            url={product.url}
          />
        ))}
      </div>
    </div>
  );
}

export default Table;